import { colors } from '../../app/variables.js'

const outerStyle = {
  textAlign: 'center',
  maxWidth: '500px',
  margin: 'auto'
}

const imgStyle = {
  width: '50%'
}

const deviceInfoStyle = {
  width: '100%',
  textAlign: 'center',
  color: 'gray',
  marginTop: '30px',
  marginBottom: '10px'
}

const formStyle = {
  maxWidth: '500px',
  padding: '10px 0',
  margin: '0 auto'
}

const buttonGroupStyle = {
  margin: '30px 0'
}

const supportButton = {
  width: '100%',
  borderRadius: '5px',
  backgroundColor: colors.lightestGray,
  border: '1px solid ' + colors.mediumGray,
  color: colors.evantaBlue,
  marginBottom: '0.5em'
}

export { outerStyle, imgStyle, deviceInfoStyle, formStyle, buttonGroupStyle, supportButton }
